// Generated by scripts/build-ui-icons.mjs.
export { CaretLeft as default } from "../ui/glyphs-2";
